import request from '@/utils/request'

/**
 * 用户管理API模块
 */
const userApi = {
  /**
   * 用户登录
   */
  login(data) {
    return request({url: '/service/sysUser/sysLogin',method: 'post',data})
  },
  // 用户登出
  logout() {
    return request({url: '/service/user/logout',method: 'put'})
  },
  // 分页查询用户列表
  querySysUsers(data) {
    return request({url: '/service/sysUser/querySysUsers',method: 'post',data})
  },
  // 新增用户
  addSysUser(data) {
    return request({url: '/service/sysUser/addSysUser',method: 'post',data})
  },
  // 删除用户
  delSysUser(id) {
    return request({url: '/service/sysUser/delSysUser?id='+id,method: 'put'})
  },
  // 修改用户
  upSysUser(data) {
    return request({url: '/service/sysUser/upSysUser',method: 'post',data})
  },
  // 修改用户状态
  upSysUserState(id,status) {
    return request({url: '/service/sysUser/upSysUserState?id='+id+'&status='+status,method: 'put'})
  },
  // 查询用户的所有角色信息
  queryUserRoles(id) {
    return request({url: '/service/sysUser/queryUserRoles?id='+id,method: 'get'})
  },
  // 删除用户的指定角色
  removeUserRole(userId,roleId) {
    return request({url: '/service/sysUser/removeUserRole?userId='+userId+'&roleId='+roleId,method: 'put'})
  },
  // 获取登录用户的菜单权限
  getUserMenu() {
    return request({url: '/service/sysUser/getUserMenu',method: 'get'})
  },
  // 获取登录用户的菜单按钮权限
  getUserMenuBtn(menuId) {
    return request({url: '/service/sysUser/getUserMenuBtn?menuId='+menuId,method: 'get'})
  },
  // 分页查询管理员操作日志列表
  querySysLog(data) {
    return request({url: '/service/sysUser/querySysLog',method:'post',data})
  },
  // 修改密码
  resetMyPwd(data) {
    return request({url: '/service/sysUser/resetMyPwd',method:'post',data})
  },
  // 修改邮箱
  upMyEmail(data) {
    return request({ url: '/service/sysUser/upMyEmail', method: 'post', data })
  },
  // 查询操作员联系人列表
  queryOperatorContacts() {
    return request({url: '/service/sysUser/queryOperatorContacts', method: 'get'})
  },
}

export default userApi